import React from "react";
import PropTypes from "prop-types";
import {
    Drawer,
    Input,
    Button,
    Row,
    Col,
    Icon,
    Timeline,
    Tag,
    message
} from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchCompanyNotes, createCompanyNotes, deleteCaseNote, retrieveCaseNote } from "store/actions";
import QueryString from "query-string";
import SingleDayNotes from "../single-day-notes";
import { STATE_STATUS } from "../../constants";

class CompanyComments extends React.Component {
    state = {
        note: null,
        actionDetailId : null,
        actionTaskId : null
    };
    componentDidMount() {
        const searchParams = QueryString.parse(window.location.search);
        if (searchParams.action_detail_id) {
            this.setState({
                actionDetailId: searchParams.action_detail_id,
                actionTaskId  : searchParams.action_task_id
            } , () => {
                this.handleNotesFetch({});
            })
        } 
    }

    componentDidUpdate(prevProps) {
        if(this.props.createNoteStatus == STATE_STATUS.FETCHED && prevProps.createNoteStatus == STATE_STATUS.FETCHING){
            this.handleNotesFetch();
        }
        if(this.props.createCaseNote == STATE_STATUS.FETCH_FAILED && prevProps.createNoteStatus == STATE_STATUS.FETCHING){
            message.error("Something Went Wrong!")
        }
    }

    handleNotesFetch = () => {
        this.props.fetchCompanyNotes(this.state.actionDetailId);      
    }

    createCaseNote = () => {
        let data = {
            "notes": this.state.note,
            "reference": null,
            "user": this.props.userId,
            "action_task": this.state.actionTaskId,
            "stage": this.props.stageId
        }
        this.props.createCompanyNotes(data)
        this.setState({
            note: null
        });
    };

    activateNote = (id) => {
        this.props.retrieveCaseNote(this.props.caseId, [id]);
    }

    onEdit = event =>
        this.setState({
            note: event.target.value
        });

    closeModal = () => {
        this.setState({
            actionDetailId : null,
            actionTaskId : null    
        })
        this.props.closeCompanyTaskModal()
    }

    render() {
        return (
            <Drawer
                title={"Case Comments"}
                closable
                visible={this.props.visible}
                onClose={this.closeModal}
                placement={"right"}
                width={"40vw"}
                footer={null}
            >
                <Row>
                    <Col span={24}>
                        <Row>
                            <Col
                                span={24}
                                style={{
                                    flexGrow: 1,
                                    minHeight: "65vh",
                                    maxHeight: "65vh",
                                    overflowY: "auto"
                                }}
                                className={"p-5"}
                            >
                                <Timeline>
                                    {this.props.notes &&
                                        this.props.notes
                                            .map((_, k) => (
                                                <Timeline.Item key={_.id}>
                                                    <div>
                                                        <Tag>
                                                            {k}
                                                        </Tag>
                                                    </div>
                                                    <SingleDayNotes
                                                        notes={_}
                                                        activateNote={this.activateNote}
                                                    />
                                                </Timeline.Item>
                                            )).toList()}
                                </Timeline>
                            </Col>
                            <Col span={24} className={"mb-5 px-5 mt-10"}>
                                <Input.TextArea
                                    rows={4}
                                    style={{ width: "100%" }}
                                    placeholder={"Add case note..."}
                                    value={this.state.note}
                                    onChange={this.onEdit}
                                />
                            </Col>
                            <Col
                                span={24}
                                className={"px-5 d-flex justify-content-flex-end"}
                            >
                                <Button
                                    type={"primary"}
                                    block={true}
                                    onClick={this.createCaseNote}
                                    disabled={!(this.state.note)}
                                    loading={this.props.notesCreating}
                                >
                                    Submit <Icon type={"plus"} />
                                </Button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Drawer>
        );
    }
}

CompanyComments.propTypes = {
    stageId : PropTypes.string,
    notesCreating: PropTypes.bool,
    visible : PropTypes.bool,
    userId : PropTypes.string
};

const mapStateToProps = (state, props) => {
    return {
        notes : state.companies.getIn(['notes' , 'data' ]),
        createNoteStatus : state.companies.get('createNoteStatus' , STATE_STATUS.UNFETCHED),

    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchCompanyNotes,
            createCompanyNotes,
            deleteCaseNote,
            retrieveCaseNote
        },
        dispatch
    );

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CompanyComments);
